// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Chrome no longer gates install on a service worker, but Samsung Internet
// and older Chromium builds still do (#2903).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker")
}

Turbo.StreamActions.close_frame_dialog = function() {
  this.targetElements.forEach((e) => e.closest("dialog").close())
}

// After a stream replaced the element that opened a dialog, the dialog's own
// focus restore has nothing to return to and focus falls to body; the
// stream names where it goes instead.
Turbo.StreamActions.focus = function() {
  this.targetElements[0]?.focus()
}

Turbo.StreamActions.exit_bulk_mode = function() {
  window.dispatchEvent(new CustomEvent("bulk-select:reset"))
}

// A frame fetch that gets redirected (dead session → sign-in, lapsed
// subscription → subscribe page) resolves to a page with no matching frame.
// Turbo's default is a console error and an empty frame — invisible to the
// user, and inside a dialog it reads as a blank drawer (#2818). Promote the
// response to a full-page visit instead.
document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault()
  event.detail.visit(event.detail.response)
})

// A stream cannot redirect; a mutation answered with a stream that must
// leave the page (deleting the folder being viewed) carries this instead.
Turbo.StreamActions.visit = function() {
  Turbo.visit(this.getAttribute("url"))
}

// Bulk delete/move on the search page removes result cards, but the search
// index only forgets them asynchronously — a server re-count would return
// the stale total. The page itself knows the number it shows; adjust it.
Turbo.StreamActions.decrement_count = function() {
  const by = parseInt(this.getAttribute("by"), 10)
  this.targetElements.forEach((el) => {
    const number = el.querySelector("[data-count]")
    if (!number) return
    const next = Math.max(0, parseInt(number.textContent.replace(/[^0-9]/g, ""), 10) - by)
    number.textContent = next.toLocaleString("en-US")
    const noun = el.querySelector("[data-count-noun]")
    if (noun) noun.textContent = next === 1 ? noun.dataset.singular : noun.dataset.plural
  })
}
